import {NotificationType, NotificationTypeAuditTrigger} from "models"
import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import memo from "set-state-compare/build/memo"
import Nav from "./nav"
import NotificationTypeAuditTriggersTable from "components/notification-type-audit-triggers/table"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminNotificationTypesAuditTriggers extends ShapeComponent {
  setup() {
    const params = useParams()
    const {notificationType, notificationTypeId} = useModel(NotificationType, {match: {params}})
    const {t} = useI18n({namespace: "js.routes.admin.notificationTypes.notification_type_audit_triggers"})

    this.auditTriggersQuery = useMemo(() => NotificationTypeAuditTrigger.ransack({notification_type_id_eq: notificationTypeId}), [notificationTypeId])
    const canCan = useCanCan(() => [[NotificationTypeAuditTrigger, ["create"]]])

    const adminLayout = useAdminLayout()

    this.setInstance({canCan, notificationType, notificationTypeId, t})

    useMemo(() => {
      adminLayout?.setState({actions: this.actions(), active: "notification-types", headerTitle: NotificationType.humanAttributeName("auditTriggers")})
    }, [adminLayout, canCan.getCacheKey(), notificationTypeId])
  }

  render() {
    const {notificationType} = this.tt

    return (
      <View dataSet={{route: "admin/notification-types/audit-triggers"}}>
        {notificationType &&
          <Nav active="audit-triggers" className="mb-4" notificationType={notificationType} />
        }
        <NotificationTypeAuditTriggersTable
          adminLayout
          collection={this.tt.auditTriggersQuery}
        />
      </View>
    )
  }

  actions() {
    const {canCan, notificationTypeId, t} = this.tt

    return (
      <>
        {canCan.can("create", NotificationTypeAuditTrigger) &&
          <Button
            className="new-notification-type-audit-trigger-button"
            icon="plus"
            label={t(".new_audit_trigger_for_notification_type")}
            to={Routes.newAdminNotificationTypeAuditTriggerPath({notification_type_audit_trigger: {notification_type_id: notificationTypeId}})}
          />
        }
      </>
    )
  }
}))
